import React, { useContext, useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Card, Col, Modal, Row, Table, Form, Alert, ButtonGroup } from 'react-bootstrap'
import UsersRequestService from 'services/users-request'
import { Clear, Edit } from '@material-ui/icons';
import { CompanyContext } from './CompanyContext';
import { parseDateBR } from 'helpers/date';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import DatePicker, { registerLocale } from "react-datepicker";
import locale from 'date-fns/locale/pt-BR';
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import { maskPhone } from 'helpers/document';

registerLocale('pt-br', locale)


export default function CompanyUsers() {
  const company = useContext(CompanyContext)
  
  const [users, setUsers] = useState([]);
  const [showUserModal, setShowUserModal] = useState(false)
  const [showUserDeleteModal, setShowUserDeleteModal] = useState(false)
  const [userToSave, setUserToSave] = useState({})
  const [userIdToDelete, setUserIdToDelete] = useState(null)
  const [birthday, setBirthday] = useState(null)

  useEffect(() => {
    getUsers()
  }, [])

  const handleShowUserModal = () => setShowUserModal(true);

  function getUsers() {
    const renderActionsButton = user => {
      return (
        <div>
          <ButtonGroup>
            <Button
              size="sm"
              variant="info"
              onClick={() => {
                if (user.birthday === null)
                  setBirthday(null)
                else
                  setBirthday(new Date(`${user.birthday} 00:00:00`))
                  
                const _user = { ...user }
                _user['action'] = "update"
                setUserToSave(_user)
                handleShowUserModal()
              }}
            >
              <Edit fontSize="small" />
            </Button>
            <Button
              size="sm"
              variant="danger"
              onClick={() => {
                setUserIdToDelete(user.id)
                setShowUserDeleteModal(true)
              }}
            >
              <Clear fontSize="small" />
            </Button>
          </ButtonGroup>
        </div>
      )
    }

    var profiles = [];

    if (company.is_premium)
      profiles = [...profiles, ...[4, 6, 7]]

    if (company.is_masteragent)
      profiles = [...profiles, ...[46, 47, 49]]

    UsersRequestService.getByCompany(company.id, {
      params: {
        __profile_id: profiles.join()
      }
    })
      .then(({ data: response }) => {
        const usersList = response.data.map(user => {
          return {
            id: user.id,
            name: `${user.name} ${user.lastname}`,
            email: user.email,
            created_at: parseDateBR(user.created_at),
            birthday: user.birthday,
            birthday_converted: user.birthday ? parseDateBR(user.birthday) : "--",
            phone: user.phone,
            profile: user.profile.name,
            actions: renderActionsButton(user)
          }
        })
        setUsers(usersList);
      })
  }

  const handleClose = () => {
    Object.keys(userToSave).forEach(key => {
      if (key != "company_id") {
        if (key == "birthday")
          userToSave.birthday = null
        else  
          userToSave[key] = ""
      }
    })
    setShowUserModal(false)
  };
  const handleShow = () => setShowUserModal(true);
  const handleDeleteClose = () => setShowUserDeleteModal(false)

  const handleDeleteUser = () => {
    UsersRequestService.delete(userIdToDelete)
      .then(() => {
        toast.success("Usuário inativado com sucesso")
        setShowUserDeleteModal(false)
        getUsers()
      })
  }

  const handleSubmitUser = () => {
    var message = ""
    var formData = new FormData()
    formData.append('name', userToSave.name)
    formData.append('lastname', userToSave.lastname)
    formData.append('phone', userToSave.phone ?? "")
    formData.append('alias', userToSave.alias ?? "")
    formData.append('profile_id', userToSave.profile_id)
    formData.append('companies[0]', company.id)
    if (birthday)
      formData.append('birthday', moment(birthday).format('YYYY-MM-D'))

    var response = null
    if (userToSave.id) {
      message = "Dados Atualizados"
      formData.append('_method', 'put')
      formData.append('id', userToSave.id)
      response = UsersRequestService.update(userToSave.id, formData)
    } else {
      message = "Usuário Cadastrado"
      formData.append('email', userToSave.email)
      response = UsersRequestService.save(formData)
    }

    delete userToSave.action

    response
      .then(() => {
        setShowUserModal(false)
        getUsers()
        toast.success(message)
      })
  }

  const setValue = (name, value) => {
    let user_aux = { ...userToSave };
    user_aux[name] = value;
    setUserToSave({ ...user_aux });
  }

  return (<>
    <Card className="mt-2 shadow bg-white rounded">
      <Card.Body>
        <Row>
          <Col md="12" className="d-flex justify-content-between">
            <h6 className="title-dashboard">Usuários</h6>
            <Button size='sm' variant="success" onClick={() => handleShowUserModal()}>
              <FontAwesomeIcon icon={faPlus} /> Adicionar Usuário
            </Button>
          </Col>
          <Col><hr className="line"></hr></Col>
          <Col md="12">
            <Table striped bordered size='sm'>
              <thead>
                <tr>
                  <th className='text-center'>Nome</th>
                  <th className='text-center'>Email</th>
                  <th className='text-center'>Perfil</th>
                  <th className='text-center'>Telefone</th>
                  <th className='text-center'>Cadastro</th>
                  <th className='text-center'>Nascimento</th>
                  <th className='text-center'>Ações</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <tr key={user.id}>
                    <td className='text-center'>{user.name}</td>
                    <td className='text-center'>{user.email}</td>
                    <td className='text-center'>{user.profile}</td>
                    <td className='text-center'>{user.phone}</td>
                    <td className='text-center'>{user.created_at}</td>
                    <td className='text-center'>{user.birthday_converted}</td>
                    <td className='text-center'>{user.actions}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Card.Body>
    </Card>

    <Modal
      size='lg'
      backdrop="static"
      keyboard={false}
      centered
      show={showUserModal}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Cadastrar Novo Usuário</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Nome:</Form.Label>
                <Form.Control
                  as="input"
                  onChange={(e) => setValue("name", e.target.value)}
                  value={userToSave.name}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Sobrenome:</Form.Label>
                <Form.Control
                  as="input"
                  onChange={(e) => setValue("lastname", e.target.value)}
                  value={userToSave.lastname}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Email:</Form.Label>
                <Form.Control
                  as="input"
                  disabled={userToSave.action}
                  onChange={(e) => setValue("email", e.target.value)}
                  value={userToSave.email}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Data de Nascimento:</Form.Label>
                <DatePicker
                  maxDate={new Date()}
                  dateFormat="dd/MM/yyyy"
                  locale='pt-br'
                  selected={birthday}
                  onChange={(date) => setBirthday(date)}
                  className="form-control"
                  showYearDropdown
                />
                {/*<Form.Control
                  as="input"
                  disabled={userToSave.action}
                  onChange={(e) => setValue("birthday", e.target.value)}
                  value={userToSave.birthday}
                />*/}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Telefone:</Form.Label>
                <Form.Control
                  as="input"
                  onChange={(e) => setValue("phone", e.target.value)}
                  value={maskPhone(userToSave.phone ?? "")}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Apelido:</Form.Label>
                <Form.Control
                  as="input"
                  onChange={(e) => setValue("alias", e.target.value)}
                  value={userToSave.alias}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Perfil:</Form.Label>
                <Form.Control
                  as="select"
                  value={userToSave.profile_id}
                  onChange={(e) => {
                    setValue("profile_id", e.target.value)
                  }}
                >
                  <option value={null} selected disabled>Selecione o Perfil</option>
                  {company.is_premium ? (<>
                    <option value="4">Revenda Master</option>
                    <option value="7">Revenda Visualizador</option>
                  </>) : (<></>)}
                  {company.is_masteragent ? (<>
                    <option value="46">Consultor de Negócio</option>
                    <option value="47">Consultor de Negócio</option>
                    <option value="49">Revenda Master Agent</option>
                  </>) : (<></>)}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSubmitUser}>
          Salvar
        </Button>
      </Modal.Footer>
    </Modal>

    <Modal
      backdrop="static"
      keyboard={false}
      show={showUserDeleteModal}
      onHide={handleClose}
    >
      <Modal.Body>
        <Alert variant="warning" className="text-center">
          Tem certeza que deseja inativar este usuário ?
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button size="sm" variant="secondary" onClick={handleDeleteClose}>
          Cancelar
        </Button>
        <Button size="sm" variant="danger" onClick={handleDeleteUser}>
          Inativar
        </Button>
      </Modal.Footer>
    </Modal>
  </>)
}